import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchEvolutionStatus,
  connectEvolution,
  deleteEvolution,
} from "./thunks";
import { toast } from "react-toastify";

interface EvolutionState {
  status: null | {
    exists: boolean;
    connected: boolean;
    instance?: any;
    qr?: { base64?: string | null; code?: string | null };
  };
  loading: boolean;
  error: string | null;
}

const initialState: EvolutionState = {
  status: null,
  loading: false,
  error: null,
};

const EvolutionSlice = createSlice({
  name: "evolution",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvolutionStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchEvolutionStatus.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          const payload = action.payload as any;
          const qrPayload =
            payload?.qr ||
            payload?.instance?.meta?.qrcode ||
            (payload?.instance?.meta
              ? {
                  base64: payload?.instance?.meta?.base64,
                  code: payload?.instance?.meta?.code,
                }
              : null) ||
            state.status?.qr ||
            null;
          state.status = qrPayload ? { ...payload, qr: qrPayload } : payload;
        },
      )
      .addCase(fetchEvolutionStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as any)?.error || null;
      })

      .addCase(connectEvolution.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        connectEvolution.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          // backend returns result (already_exists | created). Apenas atualiza a `instance` retornada —
          // não assumimos `connected: true` aqui para evitar esconder QR temporariamente.
          if (action.payload?.instance) {
            const qrPayload = action.payload?.qr ||
              action.payload?.instance?.meta?.qrcode || {
                base64: action.payload?.instance?.meta?.base64,
                code: action.payload?.instance?.meta?.code,
              };
            state.status = {
              exists: true,
              connected:
                action.payload?.instance?.connected ??
                state.status?.connected ??
                false,
              instance: action.payload.instance,
              qr: qrPayload,
            } as any;
          }
          toast.success("WhatsApp: operação concluída");
        },
      )
      .addCase(connectEvolution.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as any)?.error || null;
        toast.error("Não foi possível conectar o WhatsApp");
      })

      .addCase(deleteEvolution.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteEvolution.fulfilled, (state) => {
        state.loading = false;
        state.status = { exists: false, connected: false } as any;
        toast.success("WhatsApp removido com sucesso");
      })
      .addCase(deleteEvolution.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as any)?.error || null;
        toast.error("Não foi possível remover o WhatsApp");
      });
  },
});

export default EvolutionSlice.reducer;
